import React from 'react'
import { Row, Col, Space, Typography, Form, Button, Select, } from 'antd'
import { withRouter } from 'react-router'

import './css/gwasviz.css'

const { Paragraph } = Typography
const { Option } = Select

class GWASViz extends React.Component {
    onFinish = (values) => {
        let url = `/tool/${values.gwasviz_type}/${values.species}`
        this.props.history.push(url)
    }

    render() {
        const formItemLayout = {
            labelCol: { span: 12 },
            wrapperCol: { span: 12 },
        }
        
        return (
            <Row justify="center">
                <Col span={8}>
                    <Form {...formItemLayout}
                        layout="vertical" 
                        initialValues={{ species: 'Pop332', gwasviz_type: 'gwas_single_trait' }} 
                        onFinish={this.onFinish}
                    >
                        <Paragraph>
                            Choose a species and visualizer type to view GWAS data.
                        </Paragraph>
                        <Form.Item name="species" label="Select Population" >
                            <Select>
                                <Option value="Pop332">Pop332</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item name="gwasviz_type" label="Select GWAS Visualizer type" >
                            <Select>
                                <Option value="gwas_single_trait">GWAS Single Trait</Option>
                                <Option value="gwas_multi_trait">GWAS Multi Trait</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" className="gwasviz-search-btn" block>GO</Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        )
    }
}

export default withRouter(GWASViz)
